<template>
  <div class="waiver-section" data-cy="waiver-section">
    <!-- Warning row -->
    <div class="waiver-warning d-flex fl-row fl-a-c">
      <SvgIcon
        :iconContent="waiverIcon"
        iconAlt="waiver"
        iconStyle="width: 16px; height: 16px; margin-right: 6px; filter: brightness(0) saturate(100%) invert(72%) sepia(61%) saturate(500%) hue-rotate(1deg) brightness(103%) contrast(104%);"
      />
      <!-- The text stays rendered while the count loads, with the spinner beside it -->
      <p class="waiver-warning-text" data-cy="waiver-warning-text">
        {{
          linkedCount > 0
            ? $t("waiver.customer-has-linked", { count: linkedCount })
            : $t("waiver.customer-has-waiver-to-sign")
        }}
      </p>
      <el-icon
        v-if="isLoadingCount"
        class="is-loading waiver-spinner"
        data-cy="waiver-count-loading"
      >
        <Loading />
      </el-icon>
    </div>

    <!-- Action buttons row -->
    <div class="waiver-actions d-flex fl-row">
      <button
        class="waiver-btn"
        @click="onLinkWaiver"
        data-cy="link-waiver-btn"
      >
        {{ $t("waiver.link-a-waiver") }}
        <SvgIcon
          :iconContent="linkIcon"
          iconAlt="link"
          iconStyle="width: 13px; height: 13px; margin-left: 4px; filter: brightness(0) saturate(100%) invert(100%);"
        />
      </button>
      <button
        class="waiver-btn"
        @click="onShareWaiver"
        data-cy="share-waiver-btn"
      >
        {{ $t("waiver.share-waiver") }}
        <SvgIcon
          :iconContent="qrIcon"
          iconAlt="qr"
          iconStyle="width: 13px; height: 13px; margin-left: 4px; filter: brightness(0) saturate(100%) invert(100%);"
        />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { SvgIcon } from "@/components/index";
import { Loading } from "@element-plus/icons-vue";
import ModalModule from "@/store/modules/modal";
import { ModalStatus } from "@/constants/modal";

import waiverIcon from "@/assets/images/svg/waiver-warning.svg";
import linkIcon from "@/assets/images/svg/link.svg";
import qrIcon from "@/assets/images/svg/qrIcon.svg";

export default defineComponent({
  name: "WaiverSection",
  components: { SvgIcon, Loading },
  props: {
    linkedCount: { type: Number, default: 0 },
    isLoadingCount: { type: Boolean, default: false },
  },
  setup() {
    function onLinkWaiver() {
      ModalModule.setStatus(ModalStatus.LinkWaiver);
    }

    function onShareWaiver() {
      ModalModule.setStatus(ModalStatus.ShareWaiver);
    }

    return {
      onLinkWaiver,
      onShareWaiver,
      waiverIcon,
      linkIcon,
      qrIcon,
    };
  },
});
</script>

<style lang="scss" scoped>
@use "@/styles/variables.scss" as *;

.waiver-section {
  background-color: #1e2022;
  border-radius: 4px;
  padding: 8px 10px;
  margin-bottom: 8px;
}

.waiver-warning {
  margin-bottom: 8px;

  .waiver-warning-text {
    font-size: 11px;
    font-weight: 600;
    color: #f0a500;
    line-height: 14px;
  }

  .waiver-spinner {
    color: #f0a500;
    font-size: 14px;
    margin-left: 6px;
  }
}

.waiver-actions {
  gap: 8px;
}

.waiver-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 6px 8px;
  border: none;
  border-radius: 4px;
  background-color: rgb(49, 51, 53);
  color: white;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: darken(#4b9ba5, 8%);
  }

  &:active {
    background-color: darken(#4b9ba5, 14%);
  }
}
</style>
